import React from "react";
import ReactDOM from "react-dom";
import {
  createBrowserRouter,
  createHashRouter,
  RouterProvider,
} from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import HomePage from "./Components/HomePage/HomePage";

// const importAll = (r) => {
//   return r.keys().map(r);
// };

const location = new URL(document.location)

const importDirectories = (r) => {
  const directory = r.keys().map(key => (
    {
      "path": key.replace("./", "").replace(".json", ""),
      "module": r(key)
    }
  ))
  return directory
}

// console.log(process.env.PUBLIC_URL)

// import all json files from Data folder as an array
// const dataFiles = importAll(require.context("./Data", true, /\.json$/));

const directories = importDirectories(require.context("./Data", true, /\.json$/))

// setting up browser routes
const browserRoutes = createBrowserRouter([
  // custom error message, currently blank
  {
    path: `*`,
    element: <div></div>,
  },
  // all other routes
  // ...dataFiles.map((element) => ({
  //   path: `/v2/enjmusic5ess/${element.title}/interact`,
  //   element: <App Data={element} />,
  // })),

  // new browser routes
  ...directories.map((element) => ({
    path: `/v2/${element.path}/interact`,
    element: <App Data={element.module} />
  }))
]);

// setting up hash routes for testing
const hashRoutes = createHashRouter([
  // custom error message, currently blank
  {
    basename: process.env.PUBLIC_URL,
    path: `*`,
    element: <div></div>,
  },
  {
    basename: process.env.PUBLIC_URL,
    path: `catalog`,
    element: location?.origin === "http://localhost:3000" || location?.origin === "https://music-interactive-listening-guides-wwnorton-medi-8ea0e462c0bfef.gitlab.io" ? <HomePage directories={directories} /> : <div></div>,
  },
  // all other routes
  // ...dataFiles.map((element) => ({
  //   path: `${element.title}/interact`,
  //   element: <App Data={element} />,
  // })),

  // new browser routes
  ...directories.map((element) => ({
    path: `${element.path}/interact`,
    element: <App Data={element.module} />
  }))
]);

ReactDOM.render(
  <React.StrictMode>
    <RouterProvider router={browserRoutes} />
    <RouterProvider router={hashRoutes} />
    {/* <App /> */}
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
